<template>
<div>
  <div class="form_data" v-for="(item, index) in prizeAwardsData" :key="index">
    <!-- <p>{{level[index]}}等奖<span class="dele_items" @click="dele_items(index)">删除</span></p> -->
    <el-form :rules="rules" ref="form" :model="item" label-width="90px" class="label_css">
      <el-form-item label="奖品标题：" prop="newName">
        <el-input v-model="item.newName" placeholder="最多10字。例如：一等奖" maxlength=10></el-input>
      </el-form-item>
      <el-form-item label="奖品名称：" prop="name">
        <el-input v-model="item.name" placeholder="最多20字。例如：30元无门槛优惠券" maxlength=20></el-input>
      </el-form-item>
      <el-form-item label="奖品份数：" prop="num" :class="{'is-error': showError}">
        <el-input-number class="number_text" v-model="item.num" controls-position="right" :min="1" :precision="0"></el-input-number><span class="introduce">奖品份数即为中奖人数</span>
        <div class="el-form-item__error" v-if="showError">
          奖品份数必须少于可领取的优惠券数量
        </div>
      </el-form-item>
      <el-form-item label="奖品类型：" prop="type">
        <el-checkbox-group v-model="item.type" >
          <el-checkbox label="1" name="type" @change="checked=>choose_type(checked, 1, item)">商品</el-checkbox>
          <!-- <el-checkbox label="2" name="type" @change="checked=>choose_type(checked, 2, item)">货品</el-checkbox> -->
          <el-checkbox label="3" name="type" @change="checked=>choose_type(checked, 3, item)">优惠券</el-checkbox>
          <el-checkbox label="4" name="type">邮寄奖品</el-checkbox>
          <el-checkbox label="5" name="type">其他</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <div class="choose_type" v-if="isshow">
        <el-form-item v-if="item.isCommodity" label="商品ID：" prop="goods">
          <el-input v-model="item.goods" placeholder="最多输入5个无规格商品ID，多个之间用&分隔开"></el-input>
          <div v-if="item.isSkus">
            <p class="hasskus">以下商品为多规格商品，需要选择一个规格作为奖品</p>
            <div class="choose_specifications" v-for="(i, index) in item.skuList" :key="index">
              <p class="choose_speciname">{{i.name}}</p>
              <el-select v-model="i.newCarName" placeholder="请选择">
                <el-option
                  v-for="v in i.skus"
                  :key="v.skuId"
                  :label="v.cargoName"
                  :value="v.skuId">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-if="item.isGoods" label="货品编码：" prop="cargo">
          <div class="cargo_wrapper">
            <el-table :data="item.tableData" ref="cargotable" style="width: 100%">
              <el-table-column label="货品编码" width="150">
                <template slot-scope="scope">
                  <el-input class="number_text" size="mini" v-model="scope.row.cargo" @blur="(e) => {search_cargo(e, scope)}" placeholder="请输入"></el-input>
                  <div class="el-form-item__error" v-if="scope.row.showCidError">
                    cid不正确
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="有效期" width="334">
                <template slot-scope="scope">
                  <el-select :class="['period_validity', scope.row.expiryDateType == 6 || scope.row.expiryDateType == 7 ? 'isPeriod' : '']" v-model="scope.row.expiryDateType" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >
                    </el-option>
                  </el-select>
                  <div class="validity_custom">
                    <p v-if="scope.row.expiryDateType == 6"><span class="custom_text" style="margin-left:4px">自购买日起</span><el-input-number class="custom_date" :min='1' size="mini" v-model="scope.row.periodDays"></el-input-number>天</p>
                    <p v-if="scope.row.expiryDateType == 7"><el-date-picker class="custom_date" style="width:130px" v-model="scope.row.periodDate" type="date"></el-date-picker><span class="custom_text" style="width:25px">失效</span></p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="听课平台" width="194">
                <template slot-scope="scope">
                  <el-select class="period_validity elplatform"
                    v-model="scope.row.studyPlatform"
                    multiple collapse-tags placeholder="请选择">
                    <el-option
                      v-for="item in platform"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <span :class="{dele_items, 'isDel': item.tableData.length == 1}" @click="dele_item(scope.$index, item)">删除</span>
                </template>
              </el-table-column>
            </el-table>
            <p v-if="least" class="add_cargo" @click="add_cargo(item)">+ 添加货品</p>
          </div>
        </el-form-item>
        <el-form-item v-if="item.isCoupon" label="优惠券ID：" prop="coupon">
          <el-input v-model="item.coupon" placeholder="只能输入1个优惠券ID"></el-input>
            <div class="el-form-item__error" v-if="item.isShowCouponError">
              {{item.couponText}}
            </div>
        </el-form-item>
      </div>
      <el-form-item label="中奖说明：">
        <el-input v-model="item.desc" placeholder='最多50字。例如：如何领奖、中奖后商品会自动开通等' maxlength=50></el-input>
      </el-form-item>
    </el-form>
  </div>
</div>
</template>
<script>

export default {
  data () {
    var checknum = (rule, value, callback) => {
      this.search_num(value, callback)
    }
    var checkgoods = (rule, value, callback) => {
      this.search_goods(value, callback)
    }
    var checkcargo = (rule, value, callback) => {
      // console.log(rule, value, callback);
      // this.search_cargo(callback);
    }
    var checkcoupon = (rule, value, callback) => {
      this.search_coupon(value, callback)
    }
    return {
      isshow: false,
      count: 0,
      skus: false,
      skuList: [],
      value: '',
      unReceiveNum: '',
      ptype: [],
      form: {
        name: '',
        num: 0,
        type: [],
        desc: '',
        goods: '',
        cargo: '',
        coupon: '',
        cargoname: ''
      },
      rules: {
        newName: [
          {required: true, message: '请输入奖品标题'}
        ],
        name: [
          {required: true, message: '请输入奖品名称'}
        ],
        num: [
          {required: true, validator: checknum}
        ],
        type: [
          {required: true, message: '请选择'}
        ],
        goods: [
          { required: true, validator: checkgoods }
        ],
        cargo: [
          { required: true, validator: checkcargo, trigger: 'blur' }
        ],
        coupon: [
          { required: true, validator: checkcoupon }
        ]
      },
      options: [{
        label: '自购买日起半年',
        value: 183
      }, {
        label: '自购买日起一年',
        value: 366
      }, {
        label: '自购买日起两年',
        value: 732
      }, {
        label: '自购买日起三年',
        value: 1098
      }, {
        label: '自购买日起五年',
        value: 1830
      }, {
        label: '自定义天数',
        value: 6
      }, {
        label: '自定义日期',
        value: 7
      }],
      platform: [],
      least: true,
      showError: false,
      level: ['一', '二', '三', '四', '五'],
      prizeAwardsData: []
    }
  },
  props: ['prizeData'],
  watch: {
    prizeData: {
      deep: true,
      handler (val, old) {
        if (val && Number(this.$route.query.id)) {
          this.loadPrizeData(JSON.parse(JSON.stringify(val)))
        }
      }
    }
  },
  mounted () {
    this.studyPlatform()
  },
  methods: {
    choose_type (checked, val, item) {
      this.unReceiveNum = 0
      if (item.type && item.type.length > 0) {
        this.isshow = true
      } else {
        this.isshow = false
      }
      if (checked && val === 1) {
        item.isCommodity = true
        this.ptype.push(val)
      } else if (!checked && val === 1) {
        item.isCommodity = false
        this.ptype.splice(this.ptype.indexOf(val))
        sessionStorage.setItem('formError', false)
      } else if (checked && val === 2) {
        item.isGoods = true
        this.ptype.push(val)
      } else if (!checked && val === 2) {
        item.isGoods = false
        this.ptype.splice(this.ptype.indexOf(val))
      } else if (checked && val === 3) {
        item.isCoupon = true
        this.ptype.push(val)
      } else if (!checked && val === 3) {
        item.isCoupon = false
        this.showError = false
        this.ptype.splice(this.ptype.indexOf(val))
        sessionStorage.setItem('callback', true)
      }
    },
    search_num (val, callback) {
      if (!val) {
        callback('请输入奖品份数') // eslint-disable-line
      } else {
        callback()
      }
      if (this.unReceiveNum !== '' && this.unReceiveNum >= 0) {
        if (this.unReceiveNum < val && this.ptype.indexOf(3) > -1) {
          this.showError = true
        } else {
          this.showError = false
        }
      }
    },
    search_goods (goodsVal, callback) {
      var cargolist = []
      let list = []
      for (var i in goodsVal.split('&')) {
        cargolist.push(Number(goodsVal.split('&')[i]))
      }
      this.$api.GOODSINFO({
        ids: cargolist
      }).then(res => {
        for (i in res.data) {
          console.log(res.data, 'kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk')
          if (res.data[i].hasSpecification) {
            list.push(res.data[i])
          }
        }
        var datalist = []
        _.mapKeys(res.data, function (value, key) { // eslint-disable-line
          datalist.push(key)
        })
        if (list.length > 0) {
          callback('只支持无规格商品') // eslint-disable-line
          this.prizeAwardsData[0].callback = false
          sessionStorage.setItem('formError', true)
        } else if (cargolist.length > 5) {
          callback('商品ID不得超过5个') // eslint-disable-line
          this.prizeAwardsData[0].callback = false
          sessionStorage.setItem('formError', true)
        } else if (goodsVal === '') {
          callback('请输入商品ID') // eslint-disable-line
          this.prizeAwardsData[0].callback = false
          sessionStorage.setItem('formError', true)
        } else if (_.difference(goodsVal.split('&'), datalist).length !== 0) { // eslint-disable-line
          callback('['+_.difference(goodsVal.split('&'), datalist)+']' + '商品ID不正确')// eslint-disable-line
          this.prizeAwardsData[0].callback = false
          sessionStorage.setItem('formError', true)
        } else {
          this.prizeAwardsData[0].callback = true
          sessionStorage.setItem('formError', false)
        }
        datalist.forEach(e => {
          if (res.data[e].pubStatus !== 2) {
            callback('['+ e +']' + '为非出售中商品') // eslint-disable-line
            this.prizeAwardsData[0].callback = false
            sessionStorage.setItem('formError', true)
          }
        })
        // 动态给每个奖项添加对应的sku列表
        this.$refs.form.forEach(item => {
          item.$children && item.$children.length > 0 && item.$children.forEach(v => {
            console.log(v.$options.propsData.label, v)
            if (v.$options.propsData.label === '商品ID：' && v.$parent.model.goods === goodsVal) {
              if (list && list.length > 0) {
                v.$parent.model.isSkus = false
              } else {
                v.$parent.model.isSkus = false
              }
              console.log(list, 'iiiiiiiiiiiii-99999999999999999999')
              //  解决数据修改页面不更新问题
              this.$set(v.$parent.model, 'skuList', list)
            }
          })
        })
      }, err => {
        console.log(err)
      })
    },
    search_cargo (e, scope) {
      this.$api.CARGOINFO({
        cargoCode: e.target.value.split('&')
      }).then(res => {
        if (res.code === 0) {
          if (Object.keys(res.data).length === 0) {
            scope.row.showCidError = true
          } else {
            scope.row.showCidError = false
            scope.row.expiryDateType = 366
            scope.row.studyPlatform = [1, 6]
          }
          console.log(scope)
        }
      }, err => {
        console.log(err)
      })
    },
    search_coupon (val, callback) {
      var coupons = Number(val)
      var couponlist = [coupons]
      this.$api.COUPONINFO({
        ids: couponlist
      }).then(res => {
        if (!coupons) {
          // item.isShowCouponError = true
          // item.couponText = '请输入优惠券ID';
          this.$set(this.prizeAwardsData[0], 'isShowCouponError', true)
          this.$set(this.prizeAwardsData[0], 'couponText', '请输入优惠券ID')
          return false
        }
        if (JSON.stringify(res.data) === '{}') {
          // item.isShowCouponError = true
          // item.couponText = '该优惠券ID不正确';
          this.$set(this.prizeAwardsData[0], 'isShowCouponError', true)
          this.$set(this.prizeAwardsData[0], 'couponText', '该优惠券ID不正确')
          return false
        }
        if (res.data) {
          let start = new Date(res.data[couponlist].validStartTime).getTime() / 1000
          let end = new Date(res.data[couponlist].validEndTime).getTime() / 1000
          if (res.data[couponlist].status !== 2 || res.data[couponlist].issueStatus === 2 || (res.data[couponlist].validTimeType === 1 && (parseInt(new Date().getTime() / 1000) < start || parseInt(new Date().getTime() / 1000) > end))) {
            // item.isShowCouponError = true
            // item.couponText = '该优惠券已失效';
            this.$set(this.prizeAwardsData[0], 'isShowCouponError', true)
            this.$set(this.prizeAwardsData[0], 'couponText', '该优惠券已失效')
            if (this.prizeAwardsData[0].isShowCouponError || this.showError) {
              sessionStorage.setItem('callback', false)
              this.prizeAwardsData[0].callback = false
            } else {
              sessionStorage.setItem('callback', true)
              this.prizeAwardsData[0].callback = true
            }
            return false
          }
          // item.isShowCouponError = false
          // item.couponText = ''
          this.$set(this.prizeAwardsData[0], 'isShowCouponError', false)
          this.$set(this.prizeAwardsData[0], 'couponText', '')
          this.unReceiveNum = res.data[couponlist].unReceiveNum
          this.search_num(this.prizeAwardsData[0].num, callback)
        }
        if (this.prizeAwardsData[0].isShowCouponError || this.showError) {
          sessionStorage.setItem('callback', false)
          this.prizeAwardsData[0].callback = false
        } else {
          sessionStorage.setItem('callback', true)
          this.prizeAwardsData[0].callback = true
        }
        console.log(6666, this.prizeAwardsData[0].isShowCouponError, this.showError)
      }, err => {
        console.log(err)
      })
    },
    studyPlatform () {
      this.$api.STUDYPLATFORMS().then(res => {
        this.platform = res.data
      }, err => {
        console.log(err)
      })
    },
    dele_items (val) {
      this.$emit('delAwards', val)
    },
    dele_item (row, item) {
      if (item.tableData.length === 1) {
        return
      }
      item.tableData.splice(row, 1)
    },
    add_cargo (item) {
      console.log(item, 'ooo')
      if (item.tableData.length <= 4) {
        item.tableData.push({
          cargo: '',
          expiryDateType: '',
          periodDays: '',
          periodDate: '',
          studyPlatform: [],
          showCidError: false
        })
      }
      if (item.tableData.length === 5) {
        this.least = false
      }
    },
    loadPrizeData (val) {
      // 一等奖数据
      this.prizeAwardsData = val
      this.isshow = true
      val.forEach(item => {
        this.$api.GOODSINFO({
          ids: item.goodsIdList
        }).then(res => {
          let datalist = []
          //  回显筛选出具有规格的商品数据 自行拼接 后端不返回
          _.mapKeys(res.data, function (key, val) { // eslint-disable-line
            if (key.hasSpecification) {
              datalist.push(key)
            }
          })
          datalist && datalist.length > 0 && datalist.forEach(v => {
            v.newCarName = item.goodsIdSkuList[v.id]
          })
          this.$set(item, 'skuList', datalist)
        }).catch(err => {
          console.log(err)
        })
        item.type = item.prizeType && item.prizeType.length > 0 ? item.prizeType.map(item => String(item)) : []
        item.prizeType && item.prizeType.length > 0 && item.prizeType.forEach(num => {
          switch (num) {
            case 1:
              item.isCommodity = true
              break
            case 2:
              item.isGoods = true
              break
            case 3:
              item.isCoupon = true
              break
          }
        })
        item.goods = item.goods
        item.coupon = item.coupon
        item.cargoCodeList && item.cargoCodeList.length > 0 && item.cargoCodeList.forEach(i => {
          if (i.periodDays && !i.periodDate) { // 如果是半年到五年
            if (i.periodDays === 183 || i.periodDays === 366 || i.periodDays === 732 || i.periodDays === 1098 || i.periodDays === 1830) {
              i.expiryDateType = i.periodDays
            } else { // 自定义天数
              i.expiryDateType = 6
            }
          } else { // 自定义日期
            i.expiryDateType = 7
          }
        })
        item.tableData = JSON.parse(JSON.stringify(item.cargoCodeList))
        // if (item.goodsIdSkuList && item.goodsIdSkuList !== '{}') {
        //   item.isSkus = true
        // }
      })
    }
  },
  created () {
    if (!this.$route.query.id) {
      this.prizeAwardsData = this.prizeData
    }
  }
}
</script>

<style scoped lang="scss">
.form_data {
  border-bottom: 1px solid #e5e5e5;
  padding: 20px 20px 0;
}
.form_data:last-child {
  border: 0;
}
/deep/.number_text {
  width: 70px;
  .el-input__inner {
    width: 100%;
  }
}
/deep/.custom_date {
  width: 100px;
  margin: 0 4px;
  .el-input__inner {
    width: 100%;
  }
}
/deep/.el-table tr td.el-table__cell{
  &:nth-child(2)>div{
  display: flex;
  }
}
/deep/.el-input-number.is-controls-right .el-input__inner {
  padding-left: 10px;
  padding-right: 30px;
}
/deep/.el-form-item__label {
  color: #0d152d;
  padding: 0;
}
/deep/.el-form-item .el-form-item__label {
  padding: 0;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #fe895f;
  border-color: #fe895f;
}
/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #0d152d;
}
/deep/.el-input input {
  width: 440px;
  height: 30px;
  font-size: 12px;
}
/deep/.el-input-number .el-input .el-input__inner {
  height: 30px;
}
/deep/.el-input-number.is-controls-right .el-input-number__increase {
  top: 5px;
  width: 20px;
  height: 14px;
  line-height: 15px;
}
/deep/.el-input-number.is-controls-right .el-input-number__decrease {
  top: 18px;
  width: 20px;
  height: 15px;
  line-height: 15px;
}
/deep/.el-select .el-input__inner {
  width: 120px;
}
.cargo_wrapper {
  border: 1px solid #cccccc;
  border-radius: 4px;
  .add_cargo {
    text-align: center;
    font-size: 12px;
    color: #fe895f;
    cursor: pointer;
  }
}
/deep/.el-table__header-wrapper th.is-leaf {
  font-size: 12px;
  padding: 0;
}
/deep/.period_validity {
  width: 184px;
  &.isPeriod{
    width: 122px;
  }
  .el-input__inner {
    width: 100%;
  }
}
/deep/.period_validity .el-input .el-input__inner {
  height: 30px;
}
/deep/.elplatform {
  .el-input__suffix-inner i {
    display: none;
  }
}
/deep/.period_validity .el-select__tags {
  max-width: 144px !important;
  .el-tag {
    position: relative;
    width: 82px;
    i {
      position: absolute;
      top: 5px;
      right: -2px;
    }
  }
  .el-tag:nth-child(2) {
    width: 38px;
  }
}
.el-select-dropdown__item {
  font-size: 12px;
  color: #0d152d;
  padding: 0 10px;
}
.validity_custom {
  font-size: 12px;
  // border-top: 1px solid #e6e6e6;
  // padding: 0 10px;
  .custom_title {
    color: #949bab;
  }
}
.custom_text {
  display: inline-block;
  width: 62px;
}
.custom_confirm {
  float: right;
}
.custom_confirm span {
  display: block;
  width: 44px;
	height: 24px;
  text-align: center;
  line-height: 24px;
  color: #ffffff;
  background: #fe895f;
  border-radius: 4px;
  margin-bottom: 10px;
  cursor: pointer;
}
p {
  margin: 0;
}
.introduce {
  font-size: 12px;
  color: #949bab;
  margin-left: 10px;
}
.choose_type {
  border-radius: 4px;
  background: #fafafa;
  padding: 15px 20px;
  margin-bottom: 10px;
  .hasskus {
    font-size: 12px;
    color: #949bab;
  }
  .choose_specifications {
    display: flex;
    margin-bottom: 10px;
    .choose_speciname {
      width: 296px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 24px;
    }
  }
}
.dele_items {
  font-size: 14px;
  color: #e60012;
  float: right;
  cursor: pointer;
  &.isDel{
    color: #999;
    cursor: initial;
  }
}
/deep/.el-table .el-table__cell{
  padding: 12px 0 22px;
}
/deep/.el-table .el-form-item__error{
  top: 44px;
  left: 20px;
}
/deep/.el-table td.el-table__cell .el-input--suffix .el-input__icon{
  line-height: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/offcn-teacher-lottery/content.vue